/**
 * Created by HAKUCHI on 15/10/18.
 */
import axios from 'axios';
import http from 'http';
import https from 'https';
import qs from 'qs';
import moment from 'moment';

const config = {
  // 请求头
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }
    // "X-Requested-With": "XMLHttpRequest",
  },
  // 超时设置
  timeout: 10000,
  // 跨域是否带Token
  withCredentials: true,
  // 响应的数据格式 json / blob /document /arraybuffer / text / stream
  responseType: 'json',
  // XSRF 设置
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  // 用于node.js
  httpAgent: new http.Agent({
    keepAlive: true
  }),
  httpsAgent: new https.Agent({
    keepAlive: true
  }),
  debug: true,
  crossDomain: true
};

if (process.server || !process.client) {
  config.baseURL = `http://${process.env.HOST || 'localhost'}:${process.env.PORT || 3000}`;
}

// 扩展axios
const axiosExtra = {
  onRequest(fn) {
    this.interceptors.request.use((config) => fn(config) || config);
  },
  onResponse(fn) {
    this.interceptors.response.use((response) => fn(response) || response);
  },
  onRequestError(fn) {
    this.interceptors.request.use(undefined, (error) => fn(error) || Promise.reject(error));
  },
  onResponseError(fn) {
    this.interceptors.response.use(undefined, (error) => fn(error) || Promise.reject(error));
  },
  onError(fn) {
    this.onRequestError(fn);
    this.onResponseError(fn);
  }
};

// 合并扩展
const extendAxiosInstance = (axios) => {
  for (let key in axiosExtra) {
    axios[key] = axiosExtra[key].bind(axios);
  }
};

// 配置 loading
const setupProgress = (axios) => {
  if (!process.client) {
    return;
  }

  const noopLoading = {
    finish: () => {},
    start: () => {},
    fail: () => {},
    set: () => {}
  };

  const $loading = () =>
    window.$nuxt && window.$nuxt.$loading && window.$nuxt.$loading.set ? window.$nuxt.$loading : noopLoading;

  let currentRequests = 0;

  axios.onRequest((config) => {
    if (config && config.progress === false) {
      return;
    }

    currentRequests++;
  });

  axios.onResponse((response) => {
    if (response && response.config && response.config.progress === false) {
      return;
    }

    currentRequests--;
    if (currentRequests <= 0) {
      currentRequests = 0;
      $loading().finish();
    }
  });

  axios.onError((error) => {
    if (error && error.config && error.config.progress === false) {
      return;
    }

    currentRequests--;
    $loading().fail();
    $loading().finish();
  });

  const onProgress = (e) => {
    if (!currentRequests) {
      return;
    }
    const progress = (e.loaded * 100) / (e.total * currentRequests);
    $loading().set(Math.min(100, progress));
  };

  axios.defaults.onUploadProgress = onProgress;
  axios.defaults.onDownloadProgress = onProgress;
};

const $axios = axios.create(config);

extendAxiosInstance($axios);

setupProgress($axios);

// POST 传参序列化
$axios.interceptors.request.use(
  (config) => {
    if (process.client && config.data && config.data.constructor.name == 'FormData') {
      return config;
    }
    if (config.method === 'post') {
      config.data = qs.stringify(config.data, { arrayFormat: 'brackets' });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 返回状态判断
$axios.interceptors.response.use(
  (res) => {
    return res.data || {};
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default {
  post(url, data = {}, config = {}) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[${moment().format()}] POST => `, url, '\n param:', data);
    }

    return new Promise((resolve, reject) => {
      $axios({ method: 'post', url, data: data, ...config })
        .then((res) => {
          switch (res.status + '') {
            case '1': {
              return resolve(res);
            }
            case '4': {
              console.log(`UnLogin: => `, res);
              if (process.client && window.__NUXT__ && !data.noModal) {
                __NUXT__['state']['auth']['customerInfo'] = null;
                __NUXT__['state']['auth']['showLoginModal'] = true;
              }
              return reject(res);
            }
            default: {
              console.log(`Error: => `, res);
              return reject(res);
            }
          }
        })
        .catch((e) => {
          console.log(`Error: => URL: `, url, '\n resErr:', e.Error);
          return reject(e);
        });
    });
  },
  get(url, data = {}, config = {}) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[${moment().format()}] GET => `, url, '\n param:', data);
    }

    return new Promise((resolve, reject) => {
      $axios({ method: 'get', url, params: data, ...config })
        .then((res) => {
          switch (res.status + '') {
            case '1': {
              return resolve(res);
            }
            case '4': {
              console.log(`Error: => `, res);
              return reject(res);
            }
            default: {
              console.log(`Error: => URL: `, url, '\n param:', data, res);
              return reject(res);
            }
          }
        })
        .catch((e) => {
          console.log(`Error: => URL: `, url, '\n resErr:', e.Error);
          return reject(e);
        });
    });
  },

  request(config) {
    return $axios(config);
  }
};



// WEBPACK FOOTER //
// ./src/service/axios.js